import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.pZM9Fg',
    defaultMessage: 'App reference',
  },
  description: {
    id: 'studio.JPqZ7P',
    defaultMessage: 'Reference documentation for Appsemble app definitions',
  },
  showYaml: {
    id: 'studio.4yUiUe',
    defaultMessage: 'Show YAML',
  },
});
